import React, { useState, useEffect } from "react";
import projects from "../../utils/projects.data";

import { styled } from "@mui/material";
import { motion } from "framer-motion";

const ProjectModalContainer = styled(motion.div)(() => ({
  width: "80vw",
  height: "70vh",
  backgroundColor: "green",
  position: "absolute",
}));

const ProjectImageContainer = styled(motion.div)(({ url }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.5026961468181023) 0%, rgba(0,0,0,0.499895026369923) 100%),url('${url}')`,
  // backgroundImage: `url('${url}')`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  borderRadius: 10,
  display: "grid",
  placeItems: "center",
  padding: "10px",
}));

const ProjectModal = ({ projectId }) => {
  const [project, setProject] = useState(null);

  useEffect(() => {
    const p = projects.find((a) => a.id === projectId);
    setProject(p);
  }, [project]);

  return (
    <ProjectModalContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.15 } }}
      transition={{ duration: 0.2, delay: 0.15 }}
      style={{ pointerEvents: "auto" }}
      className="overlay"
    >
      <ProjectImageContainer
        url={project?.images[0]}
        layoutId={`${project?.name}-image`}
      ></ProjectImageContainer>
    </ProjectModalContainer>
  );
};

export default ProjectModal;
